import { FC, useContext, useMemo } from "react";
import { FetchPlayerData, setNewUser } from "../utils/FetchPlayerData";
import { Player, DefaultPlayer } from "../utils/Player";
import UserContext from "../UserContext";
import { useLocation, useParams } from "react-router-dom";
import OverlayDisplay from "../components/OverlayDisplay";

const RATE_LIMITER = 300000;
const EXCEPTION_LIMITER = 30000;
const EXCEPTED_USERS = [
    'STNZ#853'
];

const checkForNewData = async (user: Player, setUser: (newUser: Player) => void) => {
    const newUser: Player = await FetchPlayerData(user.connectCode.code.replace('#', '-'));
    if (newUser && newUser.rankedNetplayProfile.ratingOrdinal !== user.rankedNetplayProfile.ratingOrdinal)
    {
        console.log('CHANGE: ', newUser.rankedNetplayProfile.ratingOrdinal, user.rankedNetplayProfile.ratingOrdinal);
        setUser(newUser);
        setTimeout(() => checkForNewData(newUser, setUser), EXCEPTED_USERS.includes(newUser.connectCode.code) ? EXCEPTION_LIMITER : RATE_LIMITER);
    }
    else
    {
        console.log('NO CHANGE');
        setTimeout(() => checkForNewData(user, setUser), EXCEPTED_USERS.includes(user.connectCode.code) ? EXCEPTION_LIMITER : RATE_LIMITER);
    }
};

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [ search ]);
}

export enum QueryKeys {
    ShowDisplayName = 'ShowDisplayName',
    ShowConnectCode = 'ShowConnectCode',
    ShowRankIcon = 'ShowRankIcon',
    ShowRankName = 'ShowRankName',
    ShowRankNumber = 'ShowRankNumber',
    ShowWinsLosses = 'ShowWinsLosses',
    BackgroundColor = 'BackgroundColor'
}

const Overlay: FC = () => {
    const { user, setUser } = useContext(UserContext);

    const params = useParams();
    const query = useQuery();

    const showDisplayName = query.get(QueryKeys.ShowDisplayName);
    const showConnectCode = query.get(QueryKeys.ShowConnectCode);
    const showRankIcon = query.get(QueryKeys.ShowRankIcon);
    const showRankName = query.get(QueryKeys.ShowRankName);
    const showRankNumber = query.get(QueryKeys.ShowRankNumber);
    const showWinsLosses = query.get(QueryKeys.ShowWinsLosses);
    const backgroundColor = query.get(QueryKeys.BackgroundColor);

    if (user === DefaultPlayer)
    {
        setNewUser(params.id, setUser);
    }
    else
    {
        setTimeout(() => checkForNewData(user, setUser), EXCEPTED_USERS.includes(user.connectCode.code) ? EXCEPTION_LIMITER : RATE_LIMITER);
    }

    let output = <div></div>;
    if (user)
    {
        output = <OverlayDisplay
            user={ user }
            showDisplayName={ !showDisplayName || showDisplayName === 'true' }
            showConnectCode={ !showConnectCode || showConnectCode === 'true' }
            showRankIcon={ !showRankIcon || showRankIcon === 'true' }
            showRankName={ !showRankName || showRankName === 'true' }
            showRankNumber={ !showRankNumber || showRankNumber === 'true' }
            showWinLoss={ !showWinsLosses || showWinsLosses === 'true' }
            backgroundColor={ backgroundColor ? backgroundColor : `rgba(35,37,44,1)` }
        />;
    }
    return output;
};

export default Overlay;